import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

interface AnnouncementCardProps {
  title: string
  message: string
  createdAt: number
  /** Dims the title when true (for read state) */
  isRead?: boolean
}

export function AnnouncementCard({
  title,
  message,
  createdAt,
  isRead = false,
}: AnnouncementCardProps) {
  return (
    <div className="bg-surface-L0 flex flex-col gap-1 min-h-9 w-full">
      <div className="flex items-center justify-between gap-2 w-full">
        <div className="flex items-center gap-[7px] min-w-0">
          <p
            className={`text-sm font-bold leading-5 truncate ${
              isRead ? 'text-content-primary-subtle' : 'text-content-primary-bold'
            }`}
          >
            {title}
          </p>
          {!isRead && (
            <span className="size-[9px] rounded-full bg-content-info-bold shrink-0" />
          )}
        </div>
        <p className="text-xs font-semibold text-content-primary-subtle leading-4 shrink-0">
          {dayjs(createdAt).fromNow()}
        </p>
      </div>
      <p className="text-sm font-normal text-content-primary-subtle leading-5 line-clamp-2">
        {message}
      </p>
    </div>
  )
}
